import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Container } from '@mui/material';
import ReactLoading from 'react-loading';

import DefaultFeedbackMessages from './defaultFeedbackMessage';
import { fetchDefaultFeedbackMessages } from '../../../modules/reports/thunks';
import Page from '../../Page';

const DefaultFeedbackPage = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const { houseRef } = useSelector(state => state.house);
  const defaultFeedbackMessages = useSelector(state => state.reports.defaultFeedbackMessages);

  useEffect(() => {
    if (houseRef && !defaultFeedbackMessages) {
      dispatch(fetchDefaultFeedbackMessages(houseRef));
    } else if (Array.isArray(defaultFeedbackMessages)) {
      setLoading(false);
    }
  }, [houseRef, defaultFeedbackMessages]);

  return (
    <Page header={{ title: 'Default Feedback Messages' }}>
      <Container disableGutters maxWidth={false}>
        {loading ? (
          <ReactLoading className="loading-spinner" type="spin" height="auto" color="black" />
        ) : (
          <DefaultFeedbackMessages
            defaultFeedbackMessages={defaultFeedbackMessages}
            houseRef={houseRef}
          />
        )}
      </Container>
    </Page>
  );
};

export default DefaultFeedbackPage;
